import { FC, useEffect } from "react";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { useHistory } from "react-router";
import { handleRefreshIntegrationMatches } from "../services/integrations/integrationSyncUpdates";
import { appLaunchUrlToPath } from "../utils/AppUrlHelper";
import { useUserLoggedIn } from "./hooks";
import { getUTMParamsFromURL } from "../services/analytics/utmAttribution";
import { mpRegisterSuperProperties } from "../services/analytics/mixpanelService";
import { trackEvent } from "../services/analytics/analyticsService";
import { routes } from "../route/constants";
import { requestInAppReview } from "../services/ratingPromptService";
import { store } from "../redux/store";

/** Deep linking code for Android and iOS */
const AppUrlListener: FC<any> = () => {
    let history = useHistory();

    useEffect(() => {
        App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
            const path = appLaunchUrlToPath(event.url);

            if (path) {
                const utmParams = getUTMParamsFromURL(event.url);
                mpRegisterSuperProperties(utmParams);
                trackEvent("DeepLinkAppOpen", {
                    urlPath: path,
                    ...utmParams,
                });

                // Ratings deep link: show the native rating request directly
                // (only when logged in) rather than navigating to a page.
                // Compare the path portion only — appLaunchUrlToPath appends any
                // query string, and ratings links commonly carry UTM params.
                if (path.split("?")[0] === routes.rate) {
                    if (store.getState().auth?.loggedIn) {
                        requestInAppReview().catch((e) =>
                            console.warn("ratingPrompt deep link failed", e)
                        );
                    }
                    return;
                }

                // check for integration match updates in case the push is about a match
                handleRefreshIntegrationMatches().catch((e) => {
                    console.log("Error refreshing integration matches", e);
                });

                if (path === "" || path === "/") {
                    // the fallback route doesn't seem to work by default
                    history.push(routes.refsixFixtures);
                } else {
                    history.push(path);
                }
            }
            // If no match, do nothing - let regular routing
            // logic take over
        });
    }, []);

    return null;
};

export default AppUrlListener;
